module.exports = __webpack_public_path__ + "img/home_city_icon4_disabled.b37d788.png";